// src/app/rootSaga.js
import { all } from 'redux-saga/effects';
import userSaga from '../features/user/userSaga';
import watchClassSection from '../features/classSection/classSectionSaga';
import watchClassPeriods from '../features/classPeriod/classPeriodsSaga';
import watchClassPeriodTeacherschedule from '../features/classPeriodTeacherschedule/classPeriodTeacherscheduleSaga';
import watchClassSubjectMapping from '../features/classSubject/classSubjectMappingSaga';
import watchClassWithDetailsMapping from '../features/classWithSeSSubDetails/classWithSectionDetailsListSaga';
// import watchClassWithStreamSubStreamSection from '../features/classWithStreamSubStreamSection/classWithStreamSubStreamSectionListSaga';
import watchSubjectBasedTeachers from '../features/subjectBasedTeachers/subjectBasedTeachersSaga';
import watchAssignedFeeStructureToCalss from '../features/assignFeetoClass/assignFeesStructureToClassSaga';
import watchSchoolProfile from '../features/schoolProfile/schoolProfileSaga';

export default function* rootSaga() {
  yield all([
    userSaga(),
     watchClassSection(),
     watchClassPeriods(),
     watchClassPeriodTeacherschedule(),
     watchClassSubjectMapping(),
     watchClassWithDetailsMapping(),
     watchSubjectBasedTeachers(),
    //  watchClassWithStreamSubStreamSection(),
     watchAssignedFeeStructureToCalss(),
     watchSchoolProfile()
  ]);
}
